
export type TAlertsCardProps = {
    className?: string;
    width?: string;
    avatarSize?: number;
    createdAt?: string;
    createdOn?: string;
    alertReadStatusHandler?: any;
    data: DataOptions;
    onShowMore?: any;
    tab?: string;
};

export type DataOptions = {
    patientName: string; 
    patientId: string; 
    alert: string;
    alertId: number;
    alertDate?: string; 
    alertReadStatus?:string;
    alertType?: string;
    isShowMore?: boolean;
}

export type TAlertsProps = {members?:any, updateMembers?: any, searchValue?:any, filterValue?: any, filterStartDate?: any, filterEndDate?: any, showRightActionBar?: any};

export const tabs = [
    {
        name: 'All Alerts',
        key: '1'
    }

];

export const membersOption = ['Ashley John', 'Aster Milton', 'Bob Dylan', 'Bobaz Darwin'];
export const colors = ['red', 'green', 'purple', 'orange'];
